if (!customElements.get('swatch-dropdown')) {
  customElements.define(
    'swatch-dropdown',
    class CustomSelect extends HTMLElement {
      constructor() {
        super()

        this.init()
      }

      init() {
        this.trigger = this.querySelector('.js-swatch-dropdown-trigger')
        this.optionsContainer = this.querySelector('.js-swatch-dropdown-options')
        this.selectedOptionName = this.querySelector('.js-selected-option-name')
        this.selectedOptionSubtitle = this.querySelector('.js-selected-option-subtitle')
        this.selectedOptionSwatch = this.querySelector('.js-selected-option-swatch')
        this.options = Array.from(this.querySelectorAll('.js-swatch-dropdown-option'))
        this.productInfo = this.closest('.product-container')
        this.variantRadios = this.closest('variant-radios') || this.closest('quickbuy-variant-radios')
        // Remove existing listeners first to prevent duplicates
        this.removeEventListeners()
        this.addEventListeners()
      }

      addEventListeners() {
        this.trigger.addEventListener('click', () => this.toggleDropdown())
        document.addEventListener('click', (e) => this.handleClickOutside(e))
        this.options.forEach((option) => {
          option.addEventListener('click', (e) => this.handleOptionClick(e))
        })
        this.variantRadios.addEventListener('change', (e) => this.handleOptionChange(e))
      }

      removeEventListeners() {
        this.trigger.removeEventListener('click', () => this.toggleDropdown())
        document.removeEventListener('click', (e) => this.handleClickOutside(e))
        this.options.forEach((option) => {
          option.removeEventListener('click', (e) => this.handleOptionClick(e))
        })
        this.variantRadios.removeEventListener('change', (e) => this.handleOptionChange(e))
      }

      handleClickOutside(e) {
        if (!this.contains(e.target)) {
          this.closeDropdown()
        }
      }

      toggleDropdown() {
        const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true'
        if (isExpanded) {
          this.closeDropdown()
        } else {
          this.openDropdown()
        }
      }
      openDropdown() {
        this.trigger.setAttribute('aria-expanded', 'true')
        this.options.hidden = false
        this.querySelector('svg').style.transition = 'all .3s'
        this.querySelector('svg').style.rotate = '180deg'
      }

      closeDropdown() {
        this.trigger.setAttribute('aria-expanded', 'false')
        this.options.hidden = true
        this.querySelector('svg').style.rotate = '0deg'
      }

      handleOptionClick(e) {
        const value = e.currentTarget.dataset.value

        // Update the trigger text
        if (!this.variantRadios) {
          this.variantRadios = this.closest('variant-radios, quickbuy-variant-radios')
        }
        let variantOption = this.variantRadios.querySelector(`[title*="${value}"]`)
        if (!variantOption) {
          const quickbuyVariantInput = this.variantRadios.querySelector(
            '.js-quickbuy-variant-single-input-for-swatch-dropdown'
          )

          if (quickbuyVariantInput) {
            quickbuyVariantInput.value = value
            quickbuyVariantInput.checked = true
            quickbuyVariantInput.dispatchEvent(new Event('change', { bubbles: true }))
          }
        }

        if (variantOption) {
          variantOption.click()
        } else {
          console.error(`No variant option found for value: ${value}`)
        }
      }

      handleOptionChange(e) {
        let option = e.target
        if (!e.target.classList.contains('js-swatch-dropdown-option')) {
          option = this.options.find((option) => option.dataset.value.toLowerCase() === e.target.value.toLowerCase())
        }

        this.value = option.dataset.value

        // Update main button display
        this.selectedOptionName.innerHTML = option.querySelector('.js-option-name').innerHTML
        this.selectedOptionSubtitle.textContent = option.querySelector('.js-option-subtitle').textContent
        this.selectedOptionSwatch.style.backgroundColor =
          option.querySelector('.js-option-swatch').style.backgroundColor
        this.selectedOptionSwatch.style.backgroundImage =
          option.querySelector('.js-option-swatch').style.backgroundImage

        // Update option in list
        this.options.forEach(
          (option) => option.ariaSelected === 'true' && option.setAttribute('aria-selected', 'false')
        )
        option.setAttribute('aria-selected', 'true')

        this.closeDropdown()
      }
    }
  )
}
